<script lang="ts">
  import * as Pancake from '@sveltejs/pancake'
  import { tweened } from 'svelte/motion'
  import { cubicOut } from 'svelte/easing'
  import { Accelerometer } from './accelerometer'
  import { Stack } from './stack'

  // TODO
  // add event handlers for bluetooth connect and disconnect
  // limit the start to one time (currently you can keep spinning up new handlers)

  const acc = new Accelerometer()

  let buffer = new Stack<number>({ length: 1000, fill: 0 })

  $: data = buffer.array.map((value, index) => {
    return { x: index, y: value }
  })

  let maxValue = tweened(1, {
    duration: 400,
    easing: cubicOut,
  })

  let currentValue = tweened(0, {
    duration: 100,
    easing: cubicOut,
  })

  $: {
    const max = Math.max(...buffer.array)
    maxValue.set(max > 1 ? max : 1)
  }

  async function connect() {
    acc.connect()
  }

  async function disconnect() {
    acc.disconnect()
  }

  async function accel() {
    acc.startAccelerometer((acceleration) => {
      const force = Math.abs(1 - acceleration)
      currentValue.set(force)
      buffer.push($currentValue ?? 0)
      buffer = buffer
    })
  }
</script>

<button on:click={connect}>Connect</button>
<button on:click={accel}>Start</button>
<button on:click={disconnect}>Disconnect</button>

<div class="chart">
  <Pancake.Chart x1={0} x2={buffer.length} y1={0} y2={$maxValue || 1}>
    <Pancake.Grid vertical count={5} let:value>
      <span class="x-label">{buffer.length - value}</span>
    </Pancake.Grid>

    <Pancake.Grid horizontal count={5} let:value>
      <div class="grid-line horizontal"><span>{value}</span></div>
    </Pancake.Grid>

    <Pancake.Svg>
      <Pancake.SvgLine {data} let:d>
        <path class="data" {d} />
      </Pancake.SvgLine>
    </Pancake.Svg>
  </Pancake.Chart>
</div>

<style>
  .chart {
    height: 400px;
    padding: 3em 0 2em 2em;
    margin: 0 0 36px 0;
  }

  .grid-line {
    position: relative;
    display: block;
  }

  .grid-line.horizontal {
    width: calc(100% + 2em);
    left: -2em;
    border-bottom: 1px dashed #ccc;
  }

  .grid-line span {
    position: absolute;
    left: 0;
    bottom: 2px;
    font-family: sans-serif;
    font-size: 14px;
    color: #999;
  }
  .x-label {
    position: absolute;
    width: 4em;
    left: -2em;
    bottom: -22px;
    font-family: sans-serif;
    font-size: 14px;
    color: #999;
    text-align: center;
  }

  path.data {
    stroke: rgba(0, 0, 0, 0.2);
    stroke-linejoin: round;
    stroke-linecap: round;
    stroke-width: 2px;
    fill: none;
  }
</style>
